import { useState } from 'react'
import { Link, useParams } from 'react-router-dom'

import { paths } from 'src/config/paths'
import { Iconmark } from 'src/shared/components/icons/logos/iconmark'
import { Logo } from 'src/shared/components/icons/logos/logo'
import { Button } from 'src/shared/components/ui/buttons/button'
import Sidebar from 'src/shared/features/home/components/sidebar'
import { useIsMobile } from 'src/shared/hooks/use-mobile'
import { useWindowSize } from 'src/shared/hooks/use-window-size'
import { cn } from 'src/shared/utils/cn'

import AuthModal from '../../marketplace/modals/auth'

import RequestCallButton from './request-call-btn'

const PublicProfileHeader = () => {
  const isMobile = useIsMobile()
  const { width } = useWindowSize()
  const [sidebarOpen, setSidebarOpen] = useState(false)
  const { username } = useParams<{ username: string }>()
  const [showModal, setShowModal] = useState(false)
  const [authModalFlow, setAuthModalFlow] = useState<'signup' | 'login'>('login')

  const handleClientLoginClick = (signup = false) => {
    setShowModal(true)
    setAuthModalFlow(signup ? 'signup' : 'login')
  }

  return (
    <header
      className="fixed top-0 z-50 flex h-[70px] w-full items-center justify-between bg-accent p-4 md:h-[100px] md:px-8"
      style={{
        borderBottom: '0.5px solid rgba(216, 216, 214, 0.75)',
        boxShadow: '0px 4px 12px 0px rgba(27, 48, 41, 0.03)',
      }}
    >
      <div
        className={cn(
          'mx-auto flex size-full max-w-[calc(2400px-4rem)] items-center justify-between',
          'max-w-[calc(1400px-6rem)]',
        )}
      >
        <div className="flex flex-row items-center gap-4">
          <Link to={paths.root.getHref()} className="flex h-full flex-col items-start justify-center gap-2">
            {width < 450 ? (
              <Iconmark className="size-[25px] md:size-[32px]" />
            ) : (
              <Logo className="h-[22px] w-[115px] md:h-[30px] md:w-[155px]" />
            )}
          </Link>
        </div>
        <div className="flex flex-row items-center">
          {!isMobile && (
            <Button variant="outline" size="sm" className="mr-2 border-none" onClick={() => handleClientLoginClick()}>
              <p className="text-sm font-bold tracking-wide">Login</p>
            </Button>
          )}
          <RequestCallButton username={username as string} />
        </div>
      </div>
      <Sidebar isOpen={sidebarOpen} setIsOpen={setSidebarOpen} />
      <AuthModal flow={authModalFlow} open={showModal} onClose={() => setShowModal(false)} />
    </header>
  )
}

export default PublicProfileHeader
